import { render, staticRenderFns } from "./dynamicCollisionInventory.vue?vue&type=template&id=3b483a7c&"
import script from "./dynamicCollisionInventory.vue?vue&type=script&lang=js&"
export * from "./dynamicCollisionInventory.vue?vue&type=script&lang=js&"
import style0 from "./dynamicCollisionInventory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports